import { TextField } from '@material-ui/core'
import React from 'react'

const Input = ({name,value,changeValue,label,type,rowsMax=1,multiline=false}) =>
{
    return <div style={{margin:"10px 0",padding:"5px"}} >
    <TextField
    value={value}
    onChange={  e => changeValue(e.target.value)}
    rowsMax={rowsMax}
    multiline={multiline}
    type={type}
    label={label} 
    variant="outlined"
    fullWidth/>
    </div>

}

export default Input
